import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const REMARK_PLUGINS = [remarkGfm];

// Remote images are not loaded. A model can hide a request in an image URL,
// so an image is shown as a link the user can open.
function MarkdownImage({ src, alt }) {
  if (!src) return null;

  return (
    <a href={src} target="_blank" rel="noopener noreferrer">
      {alt || src}
    </a>
  );
}

function MarkdownLink({ href, children }) {
  if (!href) return children;

  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}

function MarkdownTable({ children }) {
  return (
    <div className="assistant-markdown-table">
      <table>{children}</table>
    </div>
  );
}

function MarkdownCheckbox({ checked }) {
  return <input type="checkbox" defaultChecked={Boolean(checked)} disabled />;
}

const MARKDOWN_COMPONENTS = {
  a: MarkdownLink,
  img: MarkdownImage,
  table: MarkdownTable,
  input: MarkdownCheckbox,
};

export function AssistantMarkdown({ text }) {
  return (
    <div className="assistant-markdown">
      <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={MARKDOWN_COMPONENTS}>
        {typeof text === "string" ? text : ""}
      </ReactMarkdown>
    </div>
  );
}
